var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-file-list"},_vm._l((_vm.list),function(f,index){return _c('ComFile',_vm._g(_vm._b({key:f.id,attrs:{"file":f},on:{"delete":function($event){return _vm.handleDelete($event,index)}}},'ComFile',_vm.$attrs,false),_vm.$listeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }